import { SETTINGS } from '@hotjar/webapp/constants/routes';
import { navigateTo } from '@hotjar/webapp/utils/routing/utils/navigate-to';
import type { PBContext } from '../types';

const toPlansAndBillingWithContext = (pbContext: PBContext): void => {
  return navigateTo(SETTINGS.BILLING.path, {
    'pb-context': encodeURIComponent(JSON.stringify(pbContext)),
  });
};

export { toPlansAndBillingWithContext };
